/**
 * @Time    : 2024/01/10 11:41
 * @Author  : tlovet
 * @Software: WebStorm
 */

/**
 * 布局组件-Footer
 */

import React from 'react';

const Footer: React.FC = () => {
  return (
    <></>
    // <DefaultFooter
    //   // style={{ background: 'none' }}
    //   // // copyright={`${new Date().getFullYear()} 中国航天标准化研究所@中国航天工业质量协会`}
    //   // links={
    //   //   [
    //   //     // {
    //   //     //   key: 'baidu',
    //   //     //   title: '百度',
    //   //     //   href: 'https://baidu.com',
    //   //     //   blankTarget: true,
    //   //     // },
    //   //   ]
    //   // }
    // />
  );
};

export default Footer;
